import { analyticsEvents, analyticsEventEnum } from "./events.js";
const analyticsFactory = (baseUrl, getAuthToken) => {
  async function capture(event, ...[data]) {
    if (!analyticsEvents.includes(event)) {
      throw new Error("[Analytics]: Invalid event submission");
    }
    const authToken = getAuthToken();
    await fetch(`${baseUrl}/analytics/send`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        ...authToken ? { "authorization": `Bearer ${authToken}` } : {}
      },
      body: JSON.stringify({
        event,
        data
      })
    });
  }
  return {
    capture
  };
};
export {
  analyticsEventEnum,
  analyticsFactory
};
//# sourceMappingURL=index.js.map
